import clsx from 'clsx';
import React from 'react';
import AddIcon from '../../assets/icons/add-icon.svg?react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeMdSmaller } from '../../utils/buttonSizes';

interface AddCustomIncidentTypeModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const AddCustomIncidentTypeModal: React.FC<AddCustomIncidentTypeModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
}) => {
  const addCustomIncidentTypeModalClasses = clsx(otherClasses);
  const lg = useButtonSizeMdSmaller();
  return (
    <div
      className={addCustomIncidentTypeModalClasses}
      data-testid="add-custom-incident-type-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <AddIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine">Create New Incident Category</h4>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="Category Name"
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="e.g. Near Miss"
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>

        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={lg}
            onClick={() => {
              formHandler.resetForm();
              handleClose();
            }}
            otherClasses="border-transparent text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            type="submit"
            size={lg}
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddCustomIncidentTypeModal;
